import React, { useState, useEffect, useCallback } from 'react';
import { fetchHackathonSurveyAnalytics } from '../../api/client';
import HackathonSurveyAnalytics from '../HackathonSurveyAnalytics/HackathonSurveyAnalytics';
import HackathonSurveyList from '../HackathonSurveyList/HackathonSurveyList';

export default function HackathonSurveyTab() {
  const [analytics, setAnalytics] = useState(null);

  const loadAnalytics = useCallback(async () => {
    try {
      const res = await fetchHackathonSurveyAnalytics();
      setAnalytics(res.data);
    } catch (_e) {
      setAnalytics(null);
    }
  }, []);

  useEffect(() => {
    loadAnalytics();
  }, [loadAnalytics]);

  return (
    <div>
      <HackathonSurveyAnalytics analytics={analytics} />
      <HackathonSurveyList />
    </div>
  );
}
